import React from 'react';
import _ from 'lodash';

export default class Counter extends React.Component {
  constructor(props) {
    super(props);
    this.getSelectedOption = this.getSelectedOption.bind(this);
    this.setControlState = this.setControlState.bind(this);
  }
  // give you entire json structure assinged of that particualr index
  getSelectedOption = (selectedOpt, e) => {
    if (this.props.handleSelectedOption && this.props.optionValue) {
      const _selectedOption = this.props.options.filter(option => option[this.props.optionValue].toString() === selectedOpt);
      if (this.props.id && _selectedOption && _selectedOption.length > 0) {
        _selectedOption[0].senderId = this.props.id;
      } else if (_selectedOption && _selectedOption.length === 0) {
        _selectedOption.push(selectedOpt);
      }
      this.props.handleSelectedOption(_selectedOption[0], e);
    }
  }

  clearSelectedData() {
    if (this.selectedOption) {
      this.selectedOption.selectedIndex = '';
    }
  }
  // give you only selected value.
  getValue() {
    if (this.selectedOption.selectedIndex) {
      return this.selectedOption.value;
    }
    return '';
  }
  getSelectedText() {
    return this.selectedOption.options[this.selectedOption.selectedIndex].innerText;
  }

  getID() {
    if (this.selectedOption && this.selectedOption.options && this.selectedOption.options.length) {
      const id = this.selectedOption.options[this.selectedOption.selectedIndex].id;
      return id;
    }
    return null;
  }

  getSelectedIndex() {
    return this.selectedOption.selectedIndex;
  }

  setSelectedValue = (newvalue) => {
    const slectedOption = document.querySelector('[id="' + newvalue + '"]');
    if (slectedOption) {
      slectedOption.selected = true;
    }
  }

  setControlState(isValildState, errorMessage, errorAttributes) {
    this.isControlStateValid = isValildState;
    if (isValildState && ((this.props.isMandatory && this.selectedOption.value) || (!this.props.isMandatory))) {
      this.selectedOption.classList.remove(errorAttributes.controlErrorClass);
      this.errorControl.classList.remove(errorAttributes.errorClass);
      this.errorControl.style.display = 'none';
      this.errorControl.innerHTML = '';
    } else {
      if(!this.props.src){
      this.selectedOption.classList.add(errorAttributes.controlErrorClass);
      this.errorControl.classList.add(errorAttributes.errorClass);
      this.errorControl.innerHTML = errorMessage;
      }
      this.errorControl.style.display = 'block';
    }
  }
  render() {
    const props = this.props;
    const { optionText, optionValue, optionCaption, value, disable, id, dropDownClass, classname, isCaptionDisabled, iconname, sortOptions, style, styleError, src } = this.props;
    let { options } = this.props;
    let optionHtml = [];
    let optionCaptionHtml;
    let captionText;
    if (props.isAddressForm) {
      if (props.isWeb) {
        captionText = optionCaption;
      } else {
        captionText = `${optionCaption}${props.required ? ' ' + props.star : ''}`;
      }
    } else {
      captionText = optionCaption;
    }

    if (optionCaption !== undefined) {
      const optionProps = {
        selected: 'selected',
        key: '0caption' + props.id,
      };
      optionCaptionHtml = <option {...optionProps}>{captionText}</option>;
      if (isCaptionDisabled !== undefined) {
        optionProps.disabled = isCaptionDisabled;
        optionCaptionHtml = <option {...optionProps} >{captionText}</option>;
      } else {
        optionProps.disabled = true;
        optionCaptionHtml = <option {...optionProps}>{captionText}</option>;
      }
    }
    if (options) {
      if (sortOptions) {
        options = _.sortBy(options, optionText);
      }
      optionHtml = options && options?.map((option, index) => {
        if (optionCaption && index === 0) {
          return ([
            optionCaptionHtml,
            <option
              disabled={option.disabled}
              id={option.id}
              key={index + 'option' + props.id}
              selected={optionValue ? value === option[optionValue] : false}
              value={optionValue ? option[optionValue] : null}
            >{option[optionText]}</option >]);
        }
        return (
          <option
            disabled={option.disabled}
            id={option.id} key={index + 'option' + props.id}
            selected={optionValue ? value === option[optionValue] : false}
            value={optionValue ? option[optionValue] : null}
          >{option[optionText]}</option>
        );
      });
    }
    if (!optionHtml.length) {
      optionHtml = optionCaptionHtml;
    }
    let classValue = 'icon-caret_down';
    if (iconname) {
      classValue = iconname;
    }
    return (
      <React.Fragment>
        <div className={classname} style={style}>
          <select
            id={id} disabled={disable} onChange={(option) => {
              this.getSelectedOption(option.target.value, option);
            }} ref={sel => (this.selectedOption = sel)} className={dropDownClass}
            style={{ marginBottom: '0px', color: disable ? '#b3b3b3' : 'inherit' }}
          // TODO: this style attribute will be removed once error css will be available.
          >
            {optionHtml}
          </select>
          { disable ? null : (src ? <img src={src} className='arrow_down_img'/> : (<i className={classValue} />)) }
        </div>
        {
          this.props.requiredLabel
            ? <p style={{ margin: '4px 12px 10px 0', fontSize: 12, color: '#a1a1a1' }}>{this.props.requiredLabel}</p>
            : null
        }
        <label className="error" style={styleError} ref={err => this.errorControl = err} />
      </React.Fragment>
    );
  }
}
Counter.defaultProps = {
  isMandatory: true,
};
